import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _sdkPromise = null;

const loadPayPalSdk = (clientId) => {
  if (_sdkPromise) return _sdkPromise;
  _sdkPromise = new Promise((resolve, reject) => {
    if (window.paypal) return resolve(window.paypal);
    const s = document.createElement("script");
    s.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&currency=USD&intent=capture`;
    s.async = true;
    s.onload = () => (window.paypal ? resolve(window.paypal) : reject(new Error("PayPal SDK failed to load")));
    s.onerror = () => {
      _sdkPromise = null;
      reject(new Error("PayPal SDK network error"));
    };
    document.body.appendChild(s);
  });
  return _sdkPromise;
};

export const renderPayPalButton = async ({ containerId, product, buyer, onSuccess, onError }) => {
  let cfg;
  try {
    const { data } = await axios.get(`${API}/paypal/config`);
    cfg = data;
  } catch {
    toast.error("Could not reach payment service.");
    return;
  }
  if (!cfg.enabled) {
    toast.error("PayPal is not configured on the server.");
    return;
  }
  let paypal;
  try {
    paypal = await loadPayPalSdk(cfg.client_id);
  } catch (e) {
    toast.error("Could not load PayPal.");
    return;
  }
  const container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = "";

  let currentOrderRef = null;
  paypal.Buttons({
    style: { layout: "vertical", color: "gold", shape: "rect", label: "paypal" },
    createOrder: async () => {
      const { data } = await axios.post(`${API}/paypal/orders/create`, {
        product_name: product.name,
        amount_usd: Number(product.priceUsd || 2),
        buyer_name: buyer.name,
        buyer_email: buyer.email,
        buyer_phone: buyer.phone,
        buyer_country: buyer.country || null,
      });
      currentOrderRef = data.order_ref;
      return data.paypal_order_id;
    },
    onApprove: async (data) => {
      try {
        const resp = await axios.post(`${API}/paypal/orders/capture`, {
          paypal_order_id: data.orderID,
          order_ref: currentOrderRef,
        });
        if (resp.data.ok) {
          toast.success("Payment received. We'll reach out shortly.");
          onSuccess && onSuccess();
        } else {
          toast.error(`Payment status: ${resp.data.status}`);
        }
      } catch (e) {
        toast.error("Payment captured but verification failed. Contact us with your PayPal order ID.");
        onError && onError(e);
      }
    },
    onError: (err) => {
      console.error("PayPal error", err);
      toast.error("PayPal encountered an error.");
      onError && onError(err);
    },
    onCancel: () => toast.message("Payment cancelled."),
  }).render(`#${containerId}`);
};
